export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

export const fmtNumber = (n) =>
  new Intl.NumberFormat("en-US").format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  // Guard against garbage strings making it through (e.g., legacy rows that
  // stored "TBD" or unparseable Excel dates). `new Date("TBD")` returns an
  // Invalid Date object whose `.toLocaleDateString()` is "Invalid Date" —
  // detect it and render the dash placeholder instead.
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  try {
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch {
    return "—";
  }
};

export const fmtVin = (vin) => (vin || "").toUpperCase();

// Canonical vehicle label — primary package name. Replaces the legacy
// `${v.make} ${v.model}` concat that was removed from the data model.
// Falls back to `packages[0].name` when `package_name` isn't hydrated,
// and finally to `model_category` so legacy/orphaned rows still render
// something instead of "undefined undefined".
export const vehicleLabel = (v) => {
  if (!v) return "";
  if (v.package_name) return v.package_name;
  const pkg = (v.packages && v.packages[0]) || null;
  if (pkg && pkg.name) return pkg.name;
  return v.model_category || "";
};

// Trade-in vehicle label — pulls the new `description` field, falling back
// to legacy `make + model` on historical sale docs that haven't been
// re-saved since the schema cleanup.
export const exchangeLabel = (ex) => {
  if (!ex) return "";
  if (ex.description) return ex.description;
  return [ex.make, ex.model].filter(Boolean).join(" ").trim();
};
